import {cva} from 'class-variance-authority';

export const sheetVariants = cva(
  'fixed overflow-hidden z-50 gap-4 bg-card transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500',
  {
    variants: {
      side: {
        top: 'rounded-soft inset-x-4 top-4 data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top',
        bottom:
          'rounded-soft inset-x-4 bottom-4 data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom',
        left: 'rounded-soft inset-y-4 left-4 h-[calc(100dvh-32px)] w-[calc(100%-32px)] border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm',
        right:
          'rounded-soft inset-y-4 right-4 h-[calc(100dvh-32px)] w-[calc(100%-32px)] border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm',
      },
    },
    defaultVariants: {
      side: 'right',
    },
  }
);
